// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Json__Decode from "../../../../rescript-json/lib/es6_global/src/Json__Decode.bs.js";
import * as Json__Encode from "../../../../rescript-json/lib/es6_global/src/Json__Encode.bs.js";
import * as Generic$ApiTypes from "./utils/Generic.bs.js";
import * as DeccoAdapter$ApiTypes from "./utils/DeccoAdapter.bs.js";

function color_encode(param) {
  return Json__Encode.object([
              [
                "id",
                Json__Encode.string(param.id)
              ],
              [
                "label",
                Json__Encode.string(param.label)
              ],
              [
                "tag",
                Json__Encode.string(param.tag)
              ],
              [
                "colorValue",
                Json__Encode.string(param.colorValue)
              ]
            ]);
}

var color_decode = Json__Decode.map4(Json__Decode.field("id", Json__Decode.string), Json__Decode.field("label", Json__Decode.string), Json__Decode.field("tag", Json__Decode.string), Json__Decode.field("colorValue", Json__Decode.string), (function (id, label, tag, colorValue) {
        return {
                id: id,
                label: label,
                tag: tag,
                colorValue: colorValue
              };
      }));

function image_encode(param) {
  return Json__Encode.object([
              [
                "id",
                Json__Encode.string(param.id)
              ],
              [
                "label",
                Json__Encode.string(param.label)
              ],
              [
                "tag",
                Json__Encode.string(param.tag)
              ],
              [
                "imageUrl",
                Json__Encode.string(param.imageUrl)
              ]
            ]);
}

var image_decode = Json__Decode.map4(Json__Decode.field("id", Json__Decode.string), Json__Decode.field("label", Json__Decode.string), Json__Decode.field("tag", Json__Decode.string), Json__Decode.field("imageUrl", Json__Decode.string), (function (id, label, tag, imageUrl) {
        return {
                id: id,
                label: label,
                tag: tag,
                imageUrl: imageUrl
              };
      }));

function checkbox_encode(param) {
  return Json__Encode.object([
              [
                "id",
                Json__Encode.string(param.id)
              ],
              [
                "label",
                Json__Encode.string(param.label)
              ],
              [
                "tag",
                Json__Encode.string(param.tag)
              ]
            ]);
}

var checkbox_decode = Json__Decode.map3(Json__Decode.field("id", Json__Decode.string), Json__Decode.field("label", Json__Decode.string), Json__Decode.field("tag", Json__Decode.string), (function (id, label, tag) {
        return {
                id: id,
                label: label,
                tag: tag
              };
      }));

var intermediate_decode = Json__Decode.map4(Json__Decode.field("id", Json__Decode.string), Json__Decode.field("label", Json__Decode.string), Json__Decode.field("tag", Json__Decode.string), Json__Decode.field("value", Json__Decode.option(Json__Decode.string)), (function (id, label, tag, value) {
        return {
                id: id,
                label: label,
                tag: tag,
                value: value
              };
      }));

var Item = {
  color_encode: color_encode,
  color_decode: color_decode,
  image_encode: image_encode,
  image_decode: image_decode,
  checkbox_encode: checkbox_encode,
  checkbox_decode: checkbox_decode,
  intermediate_decode: intermediate_decode
};

var partial_arg = [
  [
    "Tag",
    /* Tag */0
  ],
  [
    "Color",
    /* Color */1
  ],
  [
    "Size",
    /* Size */2
  ],
  [
    "Material",
    /* Material */3
  ],
  [
    "Pattern",
    /* Pattern */4
  ]
];

function _type_encode(param) {
  return Generic$ApiTypes.Encode.simpleVariant(partial_arg, param);
}

var _type_decode = Generic$ApiTypes.Decode.simpleVariant([
      [
        "Tag",
        /* Tag */0
      ],
      [
        "Color",
        /* Color */1
      ],
      [
        "Size",
        /* Size */2
      ],
      [
        "Material",
        /* Material */3
      ],
      [
        "Pattern",
        /* Pattern */4
      ]
    ]);

function importInfo_encode(param) {
  return Json__Encode.object([
              [
                "sectionExtractor",
                Json__Encode.string(param.sectionExtractor)
              ],
              [
                "labelExtractor",
                Json__Encode.string(param.labelExtractor)
              ]
            ]);
}

var importInfo_decode = Curry._3(Generic$ApiTypes.Decode.map2, Curry._2(Generic$ApiTypes.Decode.field, "sectionExtractor", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "labelExtractor", Generic$ApiTypes.Decode.string), (function (sectionExtractor, labelExtractor) {
        return {
                sectionExtractor: sectionExtractor,
                labelExtractor: labelExtractor
              };
      }));

function data_encode(param, optionsEncoder) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "_type",
                _type_encode(param._type)
              ],
              [
                "id",
                Curry._1(Generic$ApiTypes.Encode.string, param.id)
              ],
              [
                "label",
                Curry._1(Generic$ApiTypes.Encode.string, param.label)
              ],
              [
                "options",
                Curry._2(Generic$ApiTypes.Encode.array, param.options, optionsEncoder)
              ],
              [
                "importInfo",
                Generic$ApiTypes.Encode.nullable(param.importInfo, importInfo_encode)
              ]
            ]);
}

function data_decode(decoder) {
  return Json__Decode.map5(Json__Decode.field("_type", _type_decode), Json__Decode.field("id", Json__Decode.string), Json__Decode.field("label", Json__Decode.string), Json__Decode.field("options", Json__Decode.array(decoder)), Json__Decode.field("importInfo", Json__Decode.option(importInfo_decode)), (function (_type, id, label, options, importInfo) {
                return {
                        _type: _type,
                        id: id,
                        label: label,
                        options: options,
                        importInfo: importInfo
                      };
              }));
}

function toJson(v) {
  switch (v.TAG | 0) {
    case /* ColorCheckbox */0 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(v._0, "ColorCheckbox", (function (__x) {
                      return data_encode(__x, color_encode);
                    }));
    case /* ImageCheckbox */1 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(v._0, "ImageCheckbox", (function (__x) {
                      return data_encode(__x, image_encode);
                    }));
    case /* Checkbox */2 :
        return Generic$ApiTypes.Encode.deccoVariantWithPayload(v._0, "Checkbox", (function (__x) {
                      return data_encode(__x, checkbox_encode);
                    }));
    
  }
}

var fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("ColorCheckbox", data_decode(color_decode), (function (c) {
            return {
                    TAG: /* ColorCheckbox */0,
                    _0: c
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("ImageCheckbox", data_decode(image_decode), (function (i) {
              return {
                      TAG: /* ImageCheckbox */1,
                      _0: i
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Checkbox", data_decode(checkbox_decode), (function (c) {
              return {
                      TAG: /* Checkbox */2,
                      _0: c
                    };
            }))
    ]);

var Section = {
  data_encode: data_encode,
  data_decode: data_decode,
  toJson: toJson,
  fromJson: fromJson
};

function toJson$1(__x) {
  return Json__Encode.array(__x, toJson);
}

var fromJson$1 = Json__Decode.array(fromJson);

var include = DeccoAdapter$ApiTypes.Make({
      toJson: toJson$1,
      fromJson: fromJson$1
    });

var t_encode = include.t_encode;

var t_decode = include.t_decode;

var codec = include.codec;

export {
  Item ,
  _type_encode ,
  _type_decode ,
  importInfo_encode ,
  importInfo_decode ,
  Section ,
  toJson$1 as toJson,
  fromJson$1 as fromJson,
  t_encode ,
  t_decode ,
  codec ,
}
/* color_decode Not a pure module */
